import { html, KompisElement } from '@inter-ikea-kompis/web-component';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

/**
 * Carousel Item component.
 */

export default class CarouselItem extends KompisElement {
	/**
	 * Renders the component.
	 *
	 * @returns Template.
	 */
	public override render(): RenderResult {
		return html`
			<style>
				:host {
					display: flex;
					justify-content: center;
					align-items: center;
				}
			</style>
			<slot></slot>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-carousel-item': CarouselItem;
	}
}
